module.exports = "\n.content > * {\n    margin: 2em 1em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-details/account-details.component.css
// module id = ./src/app/account-details/account-details.component.css
// module chunks = main